import React from 'react';
import get from 'lodash/get';
import {icons,iconStyles} from './icons';
import { Icon as UIIcon } from "~/native-ui"


export default function getIcon(key, props = {}) {
    let Icon = get(icons, key);
    let iconStyle = get(iconStyles, key, {});

    const renderedIcon =  Icon ? <Icon { ...props } style={iconStyle} /> : <UIIcon { ...props } value={key} style={iconStyle} />

    return (
        <React.Fragment>{renderedIcon}</React.Fragment>
    );
}